
import defaultUser from "@/module_user/defaultUser.json";
import store from '@/store';
import {devicesMixin} from "@/utils/devices";
const APP_NAME = 'EliteFit.AI - ';

const routes = [
    
    {
        path: "/v2",
        component: () => import("@/module_homepage/views/Layout/Layout.vue"),
        redirect: getRedirectTo,
        children: [
            {
                path: "/home",
                component: () => import("@/module_homepage/views/Home4.vue"),
                name: 'Homeversion4'
            },
            {
              path: '/healthcare',
              component: () => import("@/module_homepage/views/Healthcare.vue"),
              name: "AISolutionsHealthcare",
              meta: {
                title: APP_NAME + "Healthcare",
              },
            },
            {
              path: '/fitness',
              component: () => import("@/module_homepage/views/Fitness.vue"),
              name: "AISolutionsFitness",
              meta: {
                title: APP_NAME + "Fitness",
              },
            },
            {
              path: '/sports',
              component: () => import("@/module_homepage/views/Sports.vue"),
              name: "AISolutionsSports",
              meta: {
                title: APP_NAME + "Sports",
              },
            },
            {
              path: '/insurance',
              component: () => import("@/module_homepage/views/Insurance.vue"),
              name: "AISolutionsInsurance",
              meta: {
                title: APP_NAME + "Insurance",
              },
            },
            {
              path: '/publicsector',
              component: () => import("@/module_homepage/views/Public_Sector.vue"),
              name: "AISolutionsSchools",
              meta: {
                title: APP_NAME + "PublicSector",
              },
            },
            {
              path: '/careers',
              component: () => import("@/module_homepage/views/Careers.vue"),
              name: "Careers",
              meta: {
                title: APP_NAME + "Careers",
              },
            },
            {
              path: '/faqs',
              component: () => import("@/module_homepage/views/FAQs.vue"),
              name: "FAQs",
              meta: {
                title: APP_NAME + "FAQs",
              },
            },
            {
              path: '/press',
              component: () => import("@/module_homepage/views/Press.vue"),
              name: "Press",
              meta: {
                title: APP_NAME + "Press",
              },
            },
            {
              path: '/contact-us',
              component: () => import("@/module_homepage/views/Contact.vue"),
              name: "WhyEFContactUs",
              meta: {
                title: APP_NAME + "ContactUs",
              },
            },
            {
              path: '/videos',
              component: () => import("@/module_homepage/views/Videos.vue"),
              name: "Videos",
              meta: {
                title: APP_NAME + "Videos",
              },
            },
            {
              path: '/smb',
              component: () => import("@/module_homepage/views/SMB.vue"),
              name: "SMB AI Tool",
              meta: {
                title: APP_NAME + "SMB AI Tool",
              }
            },
            {
              path: '/our-journey',
              component: () => import("@/module_homepage/views/whyelitefit.vue"),
              name: "ourJourney",
              meta: {
                title: APP_NAME + "Our journey",
              },
            },
            {
              path: '/casestudies',
              component: () => import("@/module_homepage/views/CaseStudies.vue"),
              name: "CaseStudiesMainPage",
              meta: {
                title: APP_NAME + "MainPage",
              },
            },
            {
              path: '/casestudies/sathyasai',
              component: () => import("@/module_homepage/views/SathyaSai.vue"),
              name: "CaseStudiesSathyaSai",
              meta: {
                title: APP_NAME + "SathyaSai",
              },
            },
            {
              path: '/casestudies/fita',
              component: () => import("@/module_homepage/views/Fita.vue"),
              name: "CaseStudiesFita",
              meta: {
                title: APP_NAME + "Fita",
              },
            },
            {
              path: '/casestudies/ssk',
              component: () => import("@/module_homepage/views/SSK.vue"),
              name: "CaseStudiesSSK",
              meta: {
                title: APP_NAME + "SSK",
              },
            },
            {
              path: '/casestudies/pureInternational',
              component: () => import("@/module_homepage/views/PureInternational.vue"),
              name: "CaseStudiesPureInternational",
              meta: {
                title: APP_NAME + "PureInternational",
              },
            },
            {
              path: '/casestudies/activeHealth',
              component: () => import("@/module_homepage/views/ActiveHealth.vue"),
              name: "CaseStudiesActiveHealth",
              meta: {
                title: APP_NAME + "ActiveHealth",
              },
            },
            {
              path: '/privacy-policy',
              component: () => import("@/module_homepage/views/DataInfo/PrivacyPolicy.vue"),
              name: "Privacy",
              meta: {
                title: APP_NAME + "Privacy Policy",
              },
            },
            {
              path: '/terms-of-use',
              component: () => import("@/module_homepage/views/DataInfo/TermsofUse.vue"),
              name: "termofuse",
              meta: {
                title: APP_NAME + "Terms of Use",
              },
            },
            {
              path: '/cookie-policy',
              component: () => import("@/module_homepage/views/DataInfo/Cookies.vue"),
              name: "Cookie Policy",
              meta: {
                title: APP_NAME + "Cookie Policy",
              },
            },
            {
              path: '/v2/help',
              component: () => import("@/module_homepage/views/HelpCenter.vue"),
              name: "helpCenter",
              meta: {
                title: APP_NAME + "Help Center",
              },
            },
            {
              path: '/book-a-demo',
              component: () => import("@/module_homepage/views/BookADemo.vue"),
              name: "termofuse",
              meta: {
                title: APP_NAME + "Book a demo",
              },
            },
            {
              path: '/end-workout',
              component: () => {
                // if (USE_DESKTOP_WORKOUT_UI) {
                //   return import('./views/EndWorkoutDesktop.vue');
                // }
                return import('@/module_user/views/EndWorkout.vue');
              },
              beforeEnter: checkUserLogin,
              name: "EndWorkout Anonymous",
              meta: {
                title: APP_NAME + "End Workout",
              },
            },
        ]
    },
    {
      path: "/bookdemo",        
      component: () => import("@/module_homepage/components/Form_Model.vue"),

    }
]

function isAnonymous() {
  if (store.state.userInfo) {
    return store.state.userInfo.isAnonymousUser;
  } else {
    return true;
  }
}

function isMobile() {
  return devicesMixin.computed.isMobile();
}

export async function checkUserLogin(to, from, next) {

  const localuserInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isUserInfoNotAvailable = (!localuserInfo || (localuserInfo && localuserInfo.length === 0) || Object.entries(localuserInfo).length === 0);
  // Pages that require user-data for direct access by link
  const directLinkPages = ['Home', 'Trainer Profile', 'workout', 'RepWorkout', 'HoldRepWorkout', 'SignIn', 'SessionIDSignIn', 'SignUp', 'workout Mobile'];

  // Check for user-data in web-storage. if not, create a Anonymous user
  if (isUserInfoNotAvailable) {
    let localuserInfo = defaultUser[0];
    store.dispatch('saveAnonymousUser', localuserInfo).then(() => {
      // console.log("token created");
    });
    if (!directLinkPages.includes(to.name)) {
      return next({ path: '/home' });
    }
  }

  else {

    /**
     * This array includes pages which user can't visit when he is logged in eg. sign-in & sign-up page
     * */
    const nonLoggedInPages = ['SignIn', 'SignUp'];

    /**
     * This array includes pages which user can only visit once he is logged in
     * */
    const loggedInPages = ['User Progress', 'Complete Profile'];

    /**
     * This array includes pages which only corp user can visit
     * */
    const corpLoginPages = ['leaderboard', 'CorporateDashboard'];

    // const mobilePages = ['workout'];

    // if (isMobile()) {
    //   if (mobilePages.includes(to.name)) {
    //     next(to.fullPath.replace("workout", "workout-mobile"));
    //     return;
    //   }
    // }

    if (!isAnonymous()) {
      if (nonLoggedInPages.includes(to.name)) {
        next("/");
        return;
      }
      if (corpLoginPages.includes(to.name) && !store.state.userInfo.corporate) {
        next("/");
        return;
      }
    }
    else {
      if (loggedInPages.includes(to.name) || corpLoginPages.includes(to.name)) {
        next("/");
        return;
      }
    }
  }
  next();
}

function getRedirectTo() {
  if (!isAnonymous()) {
    return store.state.defaultLandingPage;
  }
  return '/home';
}

export default routes;

